<template>
  <div>
    <div class="row">
      <div class="col-md-12 pb-0">
        <ErrorsMessages :errors="errors" />
      </div>
    </div>
    <b-overlay :show="loading" opacity="0.99">
      <div class="row mb-4" v-if="products.length == 0">
        <div class="col-md-12 w-sidebar-body">
          <h4 class="subtitles mt-2 check-text-center">
            RESIDENTE NÃO POSSUI PRODUTO(S) NO ESTOQUE.
          </h4>
        </div>
      </div>
      <!-- PRODUTO (S) COM ESTOQUE. -->
      <div class="card mb-4" v-if="products.length > 0">
        <div class="col-md-12 a-sidebar-body">
          <h4 class="subtitles mt-2 check-text-center">
            PRODUTO (S) COM ESTOQUE.
          </h4>
        </div>
        <div class="col-md-12">
          <b-overlay :show="loading" opacity="0.99">
            <div
              v-for="(product, key) in products"
              :key="key"
              class="border-bottom"
            >
              <div class="row">
                <div class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 pt-0">
                  <ProductInformation
                    :resident_id="resident_id"
                    :item="product"
                  />
                </div>
                <div
                  class="col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12 d-flex align-items-center justify-content-end"
                ></div>
              </div>
            </div>
          </b-overlay>
        </div>
      </div>
    </b-overlay>
  </div>
</template>

<script>
import ErrorsMessages from "../../Components/ErrorsMessages";

import ProductInformation from "./Product/information";

import permission from "../../../lib/permission";

import api from "../../../services/api";

import routes from "../../../routes";

export default {
  name: "StockProductView",

  components: {
    ErrorsMessages,
    ProductInformation,
  },

  data() {
    return {
      product: null,
      resident_id: null,
      products: [],
      loading: false,
      errors: [],
    };
  },

  created() {
    this.retrieve();
  },

  methods: {
    permission,

    async retrieve() {
      const { id } = routes.history.current.params;

      this.resident_id = id;

      this.get();
    },

    async get() {
      try {
        this.loading = true;

        let { resident_id } = this;

        let params = { resident_id };

        let response = await api.get("/rest-home/resident/menu-stock-product", {
          params,
        });

        let { error, errors, products } = response.data;

        if (!error) {
          this.products = products;
          this.errors = [];
        } else {
          this.errors = errors;
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    },

    handleToLot(product) {
      let { resident_id } = this;
      routes.push({
        name: "new-stock",
        query: {
          menu: "items",
          tipo: "lots",
          s: product.name,
          resident_id,
        },
      });
    },
  },
};
</script>
